import type { Object3D } from 'three';
import type { BVH } from 'three/examples/jsm/loaders/BVHLoader.js';

import type { SceneTimelineKeyPoseFromAPI } from '@cartwhl/common/types';

import {
  createEmptyKeyPoseSkeletonSnapshot,
  createSourcePoseFromApiKeyPose,
} from './keyPoseApiPayload';
import { createKeyPoseSnapshotFromSourcePose } from './keyPoseSnapshots';
import type {
  KeyPoseSkeletonSnapshot,
  KeyPoseSourcePosePayload,
} from './types';

export type RecoveredKeyPoseInput = {
  id?: string;
  frame: number;
  skeletonSnapshot: KeyPoseSkeletonSnapshot;
  sourcePose: KeyPoseSourcePosePayload;
};

export function createRecoveredKeyPoseInputsFromApiKeyPoses({
  actorScene,
  keyPoses,
  sourceBvh,
}: {
  actorScene?: Object3D | null;
  keyPoses: SceneTimelineKeyPoseFromAPI[];
  sourceBvh?: BVH | null;
}): RecoveredKeyPoseInput[] {
  return keyPoses.flatMap((keyPose) => {
    const sourcePose = createSourcePoseFromApiKeyPose(keyPose);
    if (!sourcePose) {
      return [];
    }

    const snapshot =
      actorScene && sourceBvh
        ? createKeyPoseSnapshotFromSourcePose({
            bvh: sourceBvh,
            scene: actorScene,
            sourcePose,
          })
        : null;

    return [
      {
        id: keyPose.id,
        frame: sourcePose.frame,
        skeletonSnapshot:
          snapshot?.skeletonSnapshot ??
          createEmptyKeyPoseSkeletonSnapshot(sourcePose.frame),
        sourcePose: snapshot?.sourcePose ?? sourcePose,
      },
    ];
  });
}
